var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinnerReversal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#DDE2F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3337 17.5599C11.3337 18.546 11.6637 19.3932 12.3237 20.1016C12.9837 20.8099 13.8064 21.2057 14.792 21.2891L13.5003 19.9974L14.667 18.8307L18.0003 22.1641L14.667 25.4974L13.5003 24.3307L14.8337 22.9974C13.3753 22.9141 12.1495 22.3516 11.1562 21.3099C10.1628 20.2682 9.66644 19.0252 9.66699 17.5807C9.66699 16.0668 10.1914 14.7857 11.2403 13.7374C12.2892 12.6891 13.5703 12.1646 15.0837 12.1641H18.0003V13.8307H15.0837C14.042 13.8307 13.1567 14.1918 12.4278 14.9141C11.6989 15.6363 11.3342 16.5182 11.3337 17.5599ZM19.667 22.9974V21.3307H26.3337V22.9974H19.667ZM19.667 18.4141V16.7474H26.3337V18.4141H19.667ZM19.667 13.8307V12.1641H26.3337V13.8307H19.667Z",
    fill: "#0020F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinnerReversal);
export default __webpack_public_path__ + "static/media/Winner_Reversal.4deee10253e3b16a5e42f6aeb85181c7.svg";
export { ForwardRef as ReactComponent };